import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { Button } from '@tis/shared-tis-ui';
import React from 'react';
import styles from '../Dialog.module.scss';

interface UpdateWarningDetailsProps {
  onClose: () => void;
}

const ContactDetailsUpdateWarning: React.FC<UpdateWarningDetailsProps> = ({
  onClose,
}) => {
  return (
    <>
      <DialogContent className={styles.dialogContent}>
        <div className={styles.dialogHeader}>
          <CheckCircleIcon className={styles.checkIcon} />
          <Typography
            component="h5"
            variant="h5"
            sx={{ fontSize: '20px', fontWeight: 'bold' }}
          >
            Updating contact details will result in logout
          </Typography>
        </div>
        <Typography>
          Updating contact details will result in logout, and you will need to
          log in with your new details. Click 'Save' on the form to continue
          updating contact details.
        </Typography>
      </DialogContent>
      <DialogActions className={styles.dialogActions}>
        <Button variant="outlined" onClick={onClose}>
          I Understand
        </Button>
      </DialogActions>
    </>
  );
};

export default ContactDetailsUpdateWarning;
